/**
 * Canonical language key: lowercase, REGION PRESERVED. This is the key form used
 * across the whole stack (backend storage, content-gen translation target, FE
 * lookup). `tr-TR` → `tr-tr`, `fr-CA` → `fr-ca`, `en` → `en`.
 * IMPORTANT: do NOT strip the region — `fr-CA` and `fr-FR` are distinct
 * localizations and must not collide.
 */
export function canonicalLanguageKey(code: string | undefined | null): string {
  if (!code) return '';
  return code.toLowerCase();
}

/**
 * True iff two codes refer to the same localization. Region-aware:
 * `fr-CA` ≡ `fr-ca` but `fr-CA` ≠ `fr` and `fr-CA` ≠ `fr-FR`.
 */
export function sameLanguage(
  a: string | undefined | null,
  b: string | undefined | null
): boolean {
  return (
    Boolean(a) &&
    Boolean(b) &&
    canonicalLanguageKey(a) === canonicalLanguageKey(b)
  );
}
